import { render, staticRenderFns } from "./version.vue?vue&type=template&id=4e7503ec&scoped=true&lang=html&"
import script from "./version.vue?vue&type=script&lang=js&"
export * from "./version.vue?vue&type=script&lang=js&"
import style0 from "./version.vue?vue&type=style&index=0&id=4e7503ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7503ec",
  null
  
)

component.options.__file = "version.vue"
export default component.exports